// login
const INVALID_USER = 'Email must be a valid email address!';
const INVALID_PASSWORD = 'Password is required!';
const LOGIN_ERROR = 'Incorrect username or password';
const LOGIN_WARNING_REQUIRES_NEW_PASSWORD = 'You need to reset your password';
const UNAUTHORIZED = 'You are not authorized';
const EXPENSE_FILE_MESSAGES = {
    success: 'Successfully uploaded file',
    checkError: 'Please check the following errors in your XLSX.'
}
const PROJECT_BULK_UPLOAD_MESSAGES = {
    success: 'Successfully uploaded file',
    checkError: 'Please check the following errors in your XLSX.'
}
export  {
    // login section
    INVALID_USER,
    INVALID_PASSWORD,
    LOGIN_ERROR,
    LOGIN_WARNING_REQUIRES_NEW_PASSWORD,
    UNAUTHORIZED,
    EXPENSE_FILE_MESSAGES,
    PROJECT_BULK_UPLOAD_MESSAGES
  }
